import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import type { IHeaderParams } from 'ag-grid-community';

@Component({
  selector: 'app-linked-investments-header',
  standalone: true,
  template: `
    <div class="custom-header">
      <i class="fal fa-link header-icon"></i>
      <i (click)="onFilterClick($event)" class="far fa-magnifying-glass filter-icon"></i>
    </div>
  `,
  styles: [`
    .custom-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      width: 100%;
      height: 100%;
    }

    .header-icon {
      font-size: 1.1rem;
      color: inherit;
    }

    .filter-icon {
      cursor: pointer;
      font-size: 0.8rem;
    }
  `],
})
export class LinkedInvestmentsHeaderComponent implements IHeaderAngularComp {
  params!: IHeaderParams;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  onFilterClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.params.showFilter(event.currentTarget as HTMLElement)
  }

}
